// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 1335); hand-edits allowed (see docs/architecture.md)

/** `this.RIPS_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_RIPS_DEF(): any {
  return {
    "rip_1": {
      "limit": 1,
      "level": 1,
      "id": 1,
      "gold": 100,
      "diam": 1,
      "req": "none",
      "req_amnt": 0,
      "name": "Гроб №1"
    },
    "rip_2": {
      "limit": 1,
      "level": 1,
      "id": 2,
      "gold": 200,
      "diam": 1,
      "req": "level",
      "req_amnt": 2,
      "name": "Гроб №2"
    },
    "rip_3": {
      "limit": 1,
      "level": 1,
      "id": 3,
      "gold": 400,
      "diam": 1,
      "req": "level",
      "req_amnt": 4,
      "name": "Гроб №3"
    },
    "rip_4": {
      "limit": 1,
      "level": 1,
      "id": 4,
      "gold": 500,
      "diam": 1,
      "req": "level",
      "req_amnt": 6,
      "name": "Гроб №4"
    },
    "rip_5": {
      "limit": 1,
      "level": 1,
      "id": 5,
      "gold": 750,
      "diam": 1,
      "req": "level",
      "req_amnt": 8,
      "name": "Гроб №5"
    },
    "rip_6": {
      "limit": 1,
      "level": 1,
      "id": 6,
      "gold": 1000,
      "diam": 1,
      "req": "level",
      "req_amnt": 10,
      "name": "Гроб №6"
    },
    "rip_7": {
      "limit": 1,
      "level": 1,
      "id": 7,
      "gold": 1250,
      "diam": 2,
      "req": "level",
      "req_amnt": 13,
      "name": "Гроб №7"
    },
    "rip_8": {
      "limit": 1,
      "level": 1,
      "id": 8,
      "gold": 1500,
      "diam": 2,
      "req": "level",
      "req_amnt": 16,
      "name": "Гроб №8"
    },
    "rip_9": {
      "limit": 1,
      "level": 1,
      "id": 9,
      "gold": 1800,
      "diam": 2,
      "req": "level",
      "req_amnt": 19,
      "name": "Гроб №9"
    },
    "rip_10": {
      "limit": 1,
      "level": 1,
      "id": 10,
      "gold": 2500,
      "diam": 3,
      "req": "level",
      "req_amnt": 22,
      "name": "Гроб №10"
    },
    "rip_11": {
      "limit": 1,
      "level": 1,
      "id": 11,
      "gold": 2800,
      "diam": 3,
      "req": "level",
      "req_amnt": 25,
      "name": "Гроб №11"
    },
    "rip_12": {
      "limit": 1,
      "level": 1,
      "id": 12,
      "gold": 3100,
      "diam": 4,
      "req": "level",
      "req_amnt": 30,
      "name": "Гроб №12"
    },
    "rip_13": {
      "limit": 1,
      "level": 1,
      "id": 13,
      "gold": 3500,
      "diam": 4,
      "req": "level",
      "req_amnt": 35,
      "name": "Гроб №13"
    },
    "rip_14": {
      "limit": 1,
      "level": 1,
      "id": 14,
      "gold": 4100,
      "diam": 5,
      "req": "level",
      "req_amnt": 40,
      "name": "Гроб №14"
    },
    "rip_15": {
      "limit": 1,
      "level": 1,
      "id": 15,
      "gold": 4400,
      "diam": 5,
      "req": "level",
      "req_amnt": 45,
      "name": "Гроб №15"
    },
    "rip_16": {
      "limit": 1,
      "level": 1,
      "id": 16,
      "gold": 4900,
      "diam": 5,
      "req": "level",
      "req_amnt": 50,
      "name": "Гроб №16"
    },
    "rip_17": {
      "limit": 1,
      "level": 1,
      "id": 17,
      "gold": 5500,
      "diam": 6,
      "req": "level",
      "req_amnt": 55,
      "name": "Гроб №17"
    },
    "rip_18": {
      "limit": 1,
      "level": 1,
      "id": 18,
      "gold": 6300,
      "diam": 7,
      "req": "level",
      "req_amnt": 60,
      "name": "Гроб №18"
    },
    "rip_19": {
      "limit": 1,
      "level": 1,
      "id": 19,
      "gold": 7900,
      "diam": 8,
      "req": "level",
      "req_amnt": 65,
      "name": "Гроб №19"
    },
    "rip_20": {
      "limit": 1,
      "level": 1,
      "id": 20,
      "gold": 15000,
      "diam": 15,
      "req": "level",
      "req_amnt": 70,
      "name": "Гроб №20"
    }
  };
}
